import { createClient } from "@supabase/supabase-js";

// Ensure these environment variables are set in Hostinger or your local .env file
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export function getStorageUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  
  // Convert internal storage paths to public URLs
  const { data } = supabase.storage.from("images").getPublicUrl(path);
  return data.publicUrl;
}
